import { transEnum } from '@luminovo/frontend-utils';

import { solutionStatusTranslations } from '../i18n';
import { SolutionStatus } from '../types';

export function formatSolutionStatus(status: SolutionStatus): string {
    return transEnum(status, solutionStatusTranslations);
}
